import React, { FunctionComponent, ReactElement } from 'react';

import styled from 'styled-components';

import { GhostButton } from 'chime-ui/components/Button';
import { ChimeLogo } from 'chime-ui/components/Icons';
import { Text } from 'chime-ui/components/Typography';
import { colors } from 'chime-ui/system';
import media from 'chime-ui/system/media';

import { useUserContext } from 'hooks/useUserContext';

import { trackCTATapped } from 'utils/segment/trackingEvents';

type HeaderProps = {
  showTagline?: boolean;
  showLogin?: boolean;
};

const Header: FunctionComponent<HeaderProps> = ({
  showTagline = false,
  showLogin = true,
}) => {
  const [userData] = useUserContext();

  const loginUrl = `${process.env.CONSUMER_HOST}/member/sign_in?src=pav2`;
  const onLoginClick = () => {
    trackCTATapped(
      'Pay Anyone',
      'Log in',
      'Landing Page',
      'pay_anyone_landing_login_button',
      userData?.publicId,
      null
    );
  };

  return (
    <HeaderLayout>
      <LogoAndLoginLayout showTagline={showTagline}>
        <ChimeLogo />
        {showLogin && (
          <Text size={'medium'} color={colors.notBlack} bold>
            <LogInButton as="a" href={loginUrl} onClick={onLoginClick}>
              Log In
            </LogInButton>
          </Text>
        )}
      </LogoAndLoginLayout>
      {showTagline && (
        <Text size={'small'} color={colors.darkGrey}>
          A better way to pay anyone
        </Text>
      )}
    </HeaderLayout>
  );
};

export default Header;

export function CenteredHeader(): ReactElement {
  return (
    <HeaderLayout>
      <LogoLayout>
        <ChimeLogo />
      </LogoLayout>
    </HeaderLayout>
  );
}

const HeaderLayout = styled.div`
  padding-top: 1rem;

  ${media.tablet`
    padding: 2rem 2rem 0 2rem;
  `}
`;

const LogoLayout = styled.div`
  display: flex;
  justify-content: center;
`;

const LogoAndLoginLayout = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

const LogInButton = styled(GhostButton)`
  position: relative;
  bottom: 0;
  text-decoration: none;
`;
